const action_header = "singleProducts/";
// Types
export default {
  GET_PRODUCT: action_header + "GET_PRODUCT",
  GET_PRODUCT_SUCCESS: action_header + "GET_PRODUCT_SUCCESS",
  GET_PRODUCT_FAILED: action_header + "GET_PRODUCT_FAILED",
  SELECT_PRODUCT_DETAIL: action_header + "SELECT_PRODUCT_DETAIL",
};
